import angular from 'angular';
import CreateNoteModalComponent from './createNote.modal.component';
export default angular.module('invision.customercare.createNoteModal', []).component('createNoteModal', CreateNoteModalComponent).name;